import * as Yup from 'yup';

export const otherIncomeValidationSchema = Yup.object().shape({
  isCurrent: Yup.boolean().nullable(),
  monthlyAmount: Yup.number(),
  incomeType: Yup.string().required('Income Type is required'),
  monthsAtJob: Yup.number().nullable(),
});
